import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgSevereIrritationEmojiSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M24 40c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16Zm0-30.5C16 9.5 9.5 16 9.5 24S16 38.5 24 38.5 38.5 32 38.5 24 32 9.5 24 9.5Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M27.79 32.88c-.62 0-1.14-.14-1.69-.29-.61-.17-1.25-.34-2.12-.34-.87 0-1.49.17-2.08.34-.52.14-1.05.29-1.68.29-1.57 0-2.84-1.28-2.84-2.84 0-1.57 1.28-2.84 2.84-2.84.62 0 1.12.15 1.6.29.58.17 1.18.34 2.15.34.98 0 1.61-.18 2.22-.35.52-.15 1.01-.28 1.6-.28 1.57 0 2.84 1.28 2.84 2.84 0 1.57-1.27 2.84-2.84 2.84Zm-3.82-2.13c1.08 0 1.88.22 2.52.39.47.13.88.24 1.3.24.74 0 1.34-.6 1.34-1.34 0-.73-.62-1.34-1.34-1.34-.39 0-.75.1-1.2.23-.64.18-1.44.41-2.63.41-1.18 0-1.95-.22-2.57-.4-.44-.13-.78-.23-1.18-.23-.75 0-1.34.59-1.34 1.34 0 .74.6 1.34 1.34 1.34.42 0 .8-.11 1.28-.24.62-.18 1.4-.4 2.48-.4Z",
    fill: "currentColor"
  }));
}

export { SvgSevereIrritationEmojiSecondary as default };
